import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./CardList.module.css";
import { CardItem } from "../index";
import Pagination from "@material-ui/lab/Pagination";
import { useDispatch } from "react-redux";
import { fetchPaginationProductRequest } from "../../../redux/ActionCreators/ProductActionCreators";
import { useRouteMatch } from "react-router-dom";
import { Typography, Grid } from "@material-ui/core";
import toArrayImageFromImageRegex from "shared/func/toArrayImageFromImageRegex";

const CardList = ({ itemOnPage, itemOnRow }) => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const [page, setPage] = useState(1);
  const myRef = React.createRef();
  const { searchProducts, categoryProducts, saleProducts } = match.params;

  useEffect(() => {
    dispatch(
      fetchPaginationProductRequest(
        page - 1,
        itemOnPage,
        searchProducts,
        "",
        categoryProducts,
        saleProducts
      )
    );
  }, [page, searchProducts, categoryProducts, saleProducts]);

  const { data, total } = useSelector((state) => {
    return state.products.list;
  });

  const handleChangePagination = (event, value) => {
    setPage(value);
    myRef.current.scrollIntoView({ behavior: "smooth" }, 500);
  };

  if (!data)
    return (
      <Typography variant="body1" gutterBottom>
        Loading...
      </Typography>
    );
  if (!data.length)
    return (
      <Typography variant="subtitle1" gutterBottom align="center">
        Oops!!! Không tìm thấy kết quả nào...
      </Typography>
    );
  return (
    <div ref={myRef}>
      <section className={styles.section_bg}>
        <div className={styles.content}>
          <Grid container>
            {data.map((item, index) => {
              return (
                <Grid item xs={12} sm={12 / itemOnRow} key={index}>
                  <CardItem
                    id={item.id}
                    imgPath={toArrayImageFromImageRegex(item.imageRegex)[0]}
                    title={item.name}
                    price={item.price}
                    priceDiscount={item.priceDiscount}
                    discount={`${
                      100 - parseInt((item.priceDiscount / item.price) * 100)
                    }%`}
                    rating={item.rating}
                    promotion={item.promotion}
                  />
                </Grid>
              );
            })}
          </Grid>
          <div className={styles.pagination_container}>
            <Pagination
              count={parseInt((total / itemOnPage).toFixed())}
              color="primary"
              size="small"
              className={styles.pagination}
              onChange={handleChangePagination}
            />
          </div>
        </div>
      </section>
    </div>
  );
};
export default CardList;
